// extracted by mini-css-extract-plugin
export default {"root":"hand-right_root__6MCGl"};